<div
	class="group relative h-[200px] w-[80vw] lg:h-[270px] bg-auto rounded-[40px] bg-center mx-auto overflow-hidden cursor-pointer shadow-[0px_10px_15px_2px_#00000010]"
>
	<a
		[href]="
			mainService.getOfferUrl(offer()) +
			'?' +
			mainService.getUrlParams(offer(), 'url', offersFacade.selected$ | async)
		"
		(click)="mainService.handleButtonClick($event, offer())"
		class="shadow-[0px_10px_15px_2px_#00000010]"
	>
		<div
			appObserveWidth
			#offerBoxMobileHighlightImage="appObserveWidth"
			class="w-full h-full rounded-[40px] bg-center bg-cover md:group-hover:scale-110 overflow-hidden transition"
		>
			@if (offer().multimedia?.length > 0 && !!offer().multimedia[0]?.multimedia.url) {
				<img
					[ngSrc]="
						offer().multimedia[0]?.multimedia.url
							| optimizedImage: { width: offerBoxMobileHighlightImage.widthDebounced() }
					"
					fill
					loading="lazy"
					[alt]="offer().product.name"
				/>
			} @else {
				<p
					class="w-full text-center h-full flex justify-center items-center border-mainColor border-1 rounded-[40px] text-mainColor font-bold"
				>
					Brak zdjęcia
				</p>
			}
		</div>
		<div
			class="flex flex-col md:flex-row justify-between md:block absolute bottom-6 left-6 p-3 w-[70%] rounded-[15px] bg-white/70"
		>
			<p
				class="text-mainColor text-sm font-bold uppercase mb-2 overflow-ellipsis whitespace-nowrap overflow-hidden"
			>
				{{ offer().product.name }}
			</p>
			<p class="text-mainColor text-base font-bold">od {{ offer().fullPrice | price }}/os</p>
		</div>
		@if (!!offer().promotion) {
			<div class="bg-accentColor">
				<p>{{ offer().promotion.name }}</p>
			</div>
		}
	</a>
</div>
